import { render, staticRenderFns } from "./DurationField.vue?vue&type=template&id=6f72d848"
import script from "./DurationField.vue?vue&type=script&lang=js"
export * from "./DurationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports